/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get("recently-viewed-products")) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
      this.template_url = this.dataset.templateUrl || "recently-viewed";
      this.url =
        theme.routes.search_url + `?view=${this.template_url}&type=product&q=`;
      this.container = this.querySelector(".products");
      this.currentId = this.dataset.productHandle;
      this.max = this.dataset.max || 8;
      this.products = "";
      if (window.localStorage) {
        let recentIds = window.localStorage.getItem("recently-viewed");
        if (recentIds && typeof recentIds !== undefined) {
          window.recentlyViewedIds = JSON.parse(recentIds);
        }
      }

      this.recentCarousel = null;

      Flickity.prototype._createResizeClass = function () {
        this.element.classList.add("flickity-resize");
      };

      Flickity.createMethods.push("_createResizeClass");

      var resize = Flickity.prototype.resize;
      Flickity.prototype.resize = function () {
        this.element.classList.remove("flickity-resize");
        resize.call(this);
        this.element.classList.add("flickity-resize");
      };
    }
    connectedCallback() {
      this.buildUrl();

      document.addEventListener("cartChanged", () => {
        if (this.recentCarousel) {
          setTimeout(() => {
            this.recentCarousel.resize();
          }, 300);
        }
      });

      document.addEventListener("cart-drawer:open", () => {
        if (this.recentCarousel) {
          setTimeout(() => {
            this.recentCarousel.resize();
          }, 300);
        }
      });
    }
    buildUrl() {
      let i = 0;
      window.recentlyViewedIds.forEach((val) => {
        // Skip current product
        if (val === this.currentId) {
          return;
        }
        // Stop at max
        if (i >= this.max) {
          return;
        }
        this.products += "handle:" + val + " OR ";
        i++;
      });

      this.url = this.url + encodeURIComponent(this.products);

      this.fetchProducts();
    }
    fetchProducts() {
      fetch(this.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector(".products");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.container.innerHTML = recommendations.innerHTML;
            this.classList.add("product-recommendations--loaded");
            window.Currency?.convertAll?.();

            this.cartCarousel = this.querySelector(".recommendations-carousel");
            if (this.cartCarousel) {
              this.recentCarousel = new Flickity(this.cartCarousel, {
                imagesLoaded: true,
                contain: true,
                prevNextButtons: false,
                pageDots: false,
                watchCSS: true,
                cellAlign: "left",
              });

              setTimeout(() => {
                this.recentCarousel.resize();
              }, 300);
            }

            let _this = this;
            this.fetchedCarousel = this.querySelector(".fetched-carousel");
            if (this.fetchedCarousel) {
              let slideshow_slides = Array.from(
                  this.fetchedCarousel.querySelectorAll(".carousel__slide"),
                ),
                autoplay =
                  this.fetchedCarousel.dataset.autoplay == "false"
                    ? false
                    : parseInt(this.fetchedCarousel.dataset.autoplay, 10),
                align =
                  this.fetchedCarousel.dataset.align == "center"
                    ? "center"
                    : "left",
                fade =
                  this.fetchedCarousel.dataset.fade == "true" ? true : false,
                prev_button =
                  this.fetchedCarousel.querySelector(".flickity-prev"),
                next_button =
                  this.fetchedCarousel.querySelector(".flickity-next"),
                progress_bar = this.fetchedCarousel.parentNode.querySelector(
                  ".flickity-progress--bar",
                ),
                rightToLeft = document.dir === "rtl",
                selectedIndex = 0,
                args = {
                  wrapAround: false,
                  cellAlign: align,
                  pageDots: false,
                  contain: true,
                  fade: fade,
                  autoPlay: autoplay,
                  rightToLeft: rightToLeft,
                  prevNextButtons: false,
                  imagesLoaded: true,
                  cellSelector: "li.carousel__slide",
                  on: {
                    ready() {
                      if (prev_button) {
                        prev_button.classList.add("disabled");
                      }
                    },
                    change() {
                      const slideWidth = this.slides[0].outerWidth;
                      const carouselWidth = this.element.offsetWidth;
                      const visibleSlides = Math.floor(
                        carouselWidth / slideWidth,
                      );
                      if (this.selectedIndex === 0) {
                        prev_button.classList.add("disabled");
                        next_button.classList.remove("disabled");
                      } else if (
                        this.selectedIndex >=
                        this.slides.length - visibleSlides
                      ) {
                        prev_button.classList.remove("disabled");
                        next_button.classList.add("disabled");
                      } else {
                        prev_button.classList.remove("disabled");
                        next_button.classList.remove("disabled");
                      }
                    },
                  },
                };

              if (slideshow_slides.length < 1) {
                return;
              }

              if (progress_bar) {
                args.wrapAround = false;
                args.on.scroll = function (progress) {
                  progress = Math.max(0, Math.min(1, progress));

                  progress_bar.style.width = progress * 100 + "%";
                };
              }
              const flkty = new Flickity(this.fetchedCarousel, args);

              // Skip resize while inside an inactive section-tab — Flickity
              // measures cells wrong in a hidden grid cell, locking a tall
              // inline height on .flickity-viewport. Tab controller triggers
              // resize() on activation to reconcile.
              const originalResize = flkty.resize.bind(flkty);
              flkty.resize = function () {
                const tab = flkty.element.closest(".section-tab");
                if (tab && !tab.classList.contains("active")) {
                  return;
                }
                originalResize();
              };
              this.flkty = flkty;

              selectedIndex = flkty.selectedIndex;

              this.fetchedCarousel.dataset.initiated = true;

              if (prev_button) {
                prev_button.addEventListener("click", (event) => {
                  flkty.previous();
                });
                prev_button.addEventListener("keyup", (event) => {
                  flkty.previous();
                });
                next_button.addEventListener("click", (event) => {
                  flkty.next();
                });
                next_button.addEventListener("keyup", (event) => {
                  flkty.next();
                });
              }
              if (Shopify.designMode) {
                this.fetchedCarousel.addEventListener(
                  "shopify:block:select",
                  (event) => {
                    let index = slideshow_slides.indexOf(event.target);
                    flkty.select(index);
                  },
                );
              }
            }
          }
        })

        .catch((e) => {
          console.error(e);
        });
    }
  }

  customElements.define("recently-viewed-products", RecentlyViewedProducts);
}
